import React, { useEffect, useRef, useState } from "react";
import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import "../css/Scholarship.css";

const Scholarship = () => {
  const formRef = useRef(null);

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    applicantName: "",
    email: "",
    phone: "",
    currentGrade: "",
    scholarshipType: "",
    studentAddress: "",
    achievements: "",
  });

  useEffect(() => {
    if (isFormOpen && formRef.current) {
      setTimeout(() => {
        formRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 150);
    }
  }, [isFormOpen]);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      applicantName: "",
      email: "",
      phone: "",
      currentGrade: "",
      scholarshipType: "",
      studentAddress: "",
      achievements: "",
    });
  };

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);

    try {
      await addDoc(collection(db, "scholarships"), {
        applicantName: formData.applicantName.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: formData.phone.trim(),
        currentGrade: formData.currentGrade.trim(),
        scholarshipType: formData.scholarshipType,
        studentAddress: formData.studentAddress.trim(),
        achievements: formData.achievements.trim(),
        appliedAt: serverTimestamp(),
      });

      alert("Scholarship Application Submitted Successfully!");

      resetForm();
      handleCloseForm();
    } catch (error) {
      console.error(error);
      alert("Unable to submit application. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="scholarship-page-wrapper">
      <section className="scholarship-hero-section">
        <div className="hero-overlay-content">
          <span className="hero-tag">
            SAHARA PUBLIC SECONDARY SCHOOL
          </span>

          <h1 className="hero-main-title">
            Educational Scholarship Program
          </h1>

          <p className="hero-sub-description">
            Empowering talented students through merit-based scholarships,
            financial assistance and opportunities that inspire academic
            excellence, leadership and innovation.
          </p>

          <div className="hero-action-buttons">
            <button
              type="button"
              className="apply-now-btn"
              onClick={handleOpenForm}
            >
              Apply For Scholarship
            </button>

            <a
              href="#explore-categories"
              className="explore-btn"
            >
              Explore Programs
            </a>
          </div>
        </div>
      </section>

      <section
        id="explore-categories"
        className="scholarship-info-container"
      >
        <div className="container">
          <div className="section-header">
            <span className="section-tag">
              SCHOLARSHIP PROGRAMS
            </span>

            <h2 className="section-heading">
              Our Scholarship Categories
            </h2>

            <p className="section-description">
              Sahara Public Secondary School believes every deserving
              student should have access to quality education. Our
              scholarship programs reward academic excellence, sports
              achievements, creativity, innovation and financial need.
            </p>
          </div>

          <div className="scholarship-grid">
            <div className="scholarship-card">
              <div className="card-icon">🎓</div>

              <h3>Academic Excellence</h3>

              <p>
                Awarded to students with outstanding academic
                performance and consistent excellence throughout the
                academic year.
              </p>
            </div>

            <div className="scholarship-card">
              <div className="card-icon">🏆</div>

              <h3>Sports Scholarship</h3>

              <p>
                Supporting talented athletes representing the school
                at district, provincial and national competitions.
              </p>
            </div>
                        <div className="scholarship-card">
              <div className="card-icon">💡</div>

              <h3>Innovation & Technology</h3>

              <p>
                For students demonstrating exceptional talent in coding,
                robotics, STEM projects and scientific innovation.
              </p>
            </div>

            <div className="scholarship-card">
              <div className="card-icon">🎨</div>

              <h3>Arts & Creativity</h3>

              <p>
                Encouraging excellence in music, dance, fine arts, theatre and
                other creative disciplines.
              </p>
            </div>

            <div className="scholarship-card">
              <div className="card-icon">🤝</div>

              <h3>Merit-Cum-Means</h3>

              <p>
                Financial assistance for deserving students from economically
                disadvantaged families.
              </p>
            </div>

            <div className="scholarship-card">
              <div className="card-icon">🌍</div>

              <h3>Global Citizen Award</h3>

              <p>
                Honouring students who demonstrate leadership, discipline,
                community service and responsible citizenship.
              </p>
            </div>
          </div>
        </div>
      </section>

      {isFormOpen && (
        <section
          ref={formRef}
          id="apply-form"
          className="scholarship-form-section-container"
        >
          <div className="container">
            <div className="scholarship-form-box">
              <button
                type="button"
                className="close-form-btn"
                onClick={handleCloseForm}
              >
                ×
              </button>

              <div className="form-heading">
                <span className="section-tag">
                  SCHOLARSHIP APPLICATION
                </span>

                <h2>Apply for Scholarship</h2>

                <p>
                  Complete the form below with accurate details. Our admission
                  team will review your application and contact you after
                  verification.
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                className="actual-scholarship-form"
              >
                <div className="form-input-row">
                  <div className="form-group">
                    <label>Student Full Name *</label>

                    <input
                      type="text"
                      name="applicantName"
                      placeholder="Enter full name"
                      value={formData.applicantName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email Address *</label>

                    <input
                      type="email"
                      name="email"
                      placeholder="example@email.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-input-row">
                  <div className="form-group">
                    <label>Phone Number *</label>

                    <input
                      type="tel"
                      name="phone"
                      placeholder="+977-98XXXXXXXX"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Current Class *</label>

                    <input
                      type="text"
                      name="currentGrade"
                      placeholder="Example : Class 8"
                      value={formData.currentGrade}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                                <div className="form-input-row">
                  <div className="form-group">
                    <label>Scholarship Category *</label>

                    <select
                      name="scholarshipType"
                      value={formData.scholarshipType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Scholarship</option>

                      <option value="Academic Excellence">
                        Academic Excellence
                      </option>

                      <option value="Sports Scholarship">
                        Sports Scholarship
                      </option>

                      <option value="Innovation & Technology">
                        Innovation & Technology
                      </option>

                      <option value="Arts & Creativity">
                        Arts & Creativity
                      </option>

                      <option value="Merit-Cum-Means">
                        Merit-Cum-Means
                      </option>

                      <option value="Global Citizen Award">
                        Global Citizen Award
                      </option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Permanent Address *</label>

                    <input
                      type="text"
                      name="studentAddress"
                      placeholder="Enter complete address"
                      value={formData.studentAddress}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group full-width-group">
                  <label>
                    Academic Achievements / Reason for Scholarship *
                  </label>

                  <textarea
                    name="achievements"
                    rows="5"
                    placeholder="Describe your achievements, awards, financial need or any other reason for applying..."
                    value={formData.achievements}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-action-buttons">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading
                      ? "Submitting..."
                      : "Submit Scholarship Application"}
                  </button>

                  <button
                    type="button"
                    className="primary-btn"
                    onClick={handleCloseForm}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      )}

      <section className="scholarship-footer-section">
        <div className="container">
          <div className="footer-content">
            <span className="section-tag">
              NEED HELP?
            </span>

            <h2>
              Have Questions About Scholarships?
            </h2>

            <p>
              Our admission counsellors are available to guide you regarding
              scholarship eligibility, required documents and the complete
              application process.
            </p>

            <div className="footer-buttons">
              <a
                href="/contact"
                className="contact-btn"
              >
                Contact Admission Office
              </a>

              <a
                href="/admission"
                className="apply-btn"
              >
                Apply for Admission
              </a>
            </div>
          </div>
        </div>
      </section>
          </div>
  );
};

export default Scholarship;